import axiosInstance from "../../../api/axiosInstance";

let getObject = (method, user, props) => {
    let uri = process.env.REACT_APP_API + "/"+ method;
    
    if(user != null && user != undefined && user != "") {
        uri = process.env.REACT_APP_API  + "/"+ method +  "/" + user.profile + "/" + user.locale;
    }

    if(props != null && props != undefined && props != "") {
        uri = process.env.REACT_APP_API  + "/"+  method + "/" + props + "/" + user.profile + "/" + user.locale;
    }

    return new Promise((resolve, reject) => { 
        axiosInstance.get(uri).then(response=> {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    })
}

export default getObject